import { useEffect, useImperativeHandle, useState } from "react";
import "./dropdown.scss";
import React from "react";
import { Color } from "../../../style/colors";
import { ReactComponent as Arrow } from "../../../../assets/arrowIcon.svg";

const Dropdown = React.forwardRef(
  (
    props: {
      title?: string;
      isLight?: boolean;
      options: Array<{ value: any; label: any }>;
      prefix?: any;
      suffix?: any;
      maxWidth?: string;
      padding?: string;
      border?: string;
      isFullWidth?: boolean;
      initialValue?: { value: any; label?: any };
      validator?: (
        e:
          | {
              value: any;
              label?: any;
            }
          | undefined
      ) => any | null;
      onChange?: (selection: { value: any; label: any }) => void;
      color?: string;
      backgroundColor?: string;
      multipleSelection?: boolean;
      disabled?: boolean;
    },
    ref
  ) => {
    const [target, setTarget] = useState<EventTarget & HTMLDivElement>();
    const [focus, setFocus] = useState<boolean>(false);
    const [selectedOption, setSelectedOption] = useState<{
      value: any;
      label?: string;
    }>();

    useImperativeHandle(ref, () => ({
      validate(): boolean {
        if (!selectedOption) {
          setSelectedOption({ label: "", value: "" });
          return props.validator?.({ label: "", value: "" }) == null;
        }
        return props.validator?.(selectedOption) == null;
      },
    }));

    const dropdownClass = [
      "dropdown",
      props.validator?.(selectedOption) ? "dropdownError" : "",
      props.validator?.(selectedOption) && focus ? "dropdownErrorFocus" : "",
      focus ? "dropdownFocus" : "",
    ].join(" ");

    useEffect(() => {
      setSelectedOption(props.initialValue);
    }, []);

    function Options() {
      return (
        <div className={"options"}>
          {props.options.map((e) => (
            <div
              key={e.value}
              className={"option"}
              onClick={() => {
                setSelectedOption(e);
                props.onChange?.(e);
                if (!props.multipleSelection) target?.blur();
              }}
            >
              {e.label}
            </div>
          ))}
        </div>
      );
    }

    return (
      <div
        style={{
          width:
            props.isFullWidth == undefined || props.isFullWidth ? "100%" : "",
          maxWidth: props.maxWidth,
          opacity: props.disabled ? "0.5" : "",
        }}
      >
        {props.title && (
          <p
            className={["title"].join(" ")}
            style={{
              color: props.color,
            }}
          >
            {props.title}
          </p>
        )}
        <div
          className={"dropdownContainer"}
          tabIndex={1}
          onFocus={(e) => {
            if (!props.disabled) {
              setFocus(true);
              setTarget(e.target);
            }
          }}
          onBlur={() => setFocus(false)}
        >
          <div
            className={dropdownClass}
            style={{
              padding: props.padding,
              border: props.border,
              backgroundColor: props.backgroundColor,
            }}
          >
            {props.prefix && <div className={"suffix"}>{props.prefix}</div>}
            <div className="selection-container">
              <div
                className={"selection"}
                style={{
                  color: props.color,
                  maxWidth: "calc(" + props.maxWidth + " - 40px)",
                }}
              >
                {selectedOption?.label || <br />}
              </div>
            </div>
            {props.suffix && (
              <div className={"suffix"} style={{ color: props.color }}>
                {props.suffix}
              </div>
            )}
            <Arrow
              height={10}
              width={10}
              stroke={props.color || Color().blackColor}
              className={focus ? "arrowUp" : "arrowDown"}
            />
          </div>
          {focus && <Options />}
        </div>
        {props.validator?.(selectedOption) && (
          <p className={"errorText"}>{props.validator?.(selectedOption)}</p>
        )}
      </div>
    );
  }
);

export default Dropdown;
